import { combineReducers } from '@reduxjs/toolkit';
import { foldersSlice } from './slices/folders';
import { albumSlice } from './slices/album';
import { photosSlice } from './slices/photos';
import { clientSlice } from './slices/client';
import { companySlice } from './slices/company';
import { albumsSlice } from './slices/albums';
import { userSlice } from './slices/user';
import { paymentsSlice } from './slices/payments';
import { transactionsSlice } from './slices/transactions';
import { analyticsSlice } from './slices/analytics';
import { videosSlice } from './slices/videos';
import { enquiriesSlice } from './slices/enquiries';
import { portfolioSlice } from './slices/portfolio';
import { referralSlice } from './slices/referral';
import { payoutsSlice } from './slices/payouts';
// import { selectionSlice } from './slices/selection';

const rootReducer = combineReducers({
  folders: foldersSlice.reducer,
  album: albumSlice.reducer,
  photos: photosSlice.reducer,
  client: clientSlice.reducer,
  company: companySlice.reducer,
  albums: albumsSlice.reducer,
  user: userSlice.reducer,
  payments: paymentsSlice.reducer,
  transactions: transactionsSlice.reducer,
  analytics: analyticsSlice.reducer,
  videos: videosSlice.reducer,
  enquiries: enquiriesSlice.reducer,
  portfolio: portfolioSlice.reducer,
  referral: referralSlice.reducer,
  payouts: payoutsSlice.reducer,
  // selection: selectionSlice.reducer,
});

export default rootReducer;
